import { User } from '@/modules/user/user';

import { triggerSequences } from '@shared/common/types/trigger-sequences';

export class Alert {
    public id!: string;
    public date!: Date;
    public type!: string;
    public json!: any;
    public gpsLocation!: any;
    public gpsDate!: any;
    public deviceId!: string;
    public createdAt!: Date;
    public createdBy?: User;
    public beacons?: any[];

    constructor(opt: any) {
        Object.assign(this, opt);

        if (this.createdBy) {
            this.createdBy = new User(this.createdBy);
        }
    }

    public get typeLabel(): string {
        const triggerSequence = triggerSequences.find((ts) => ts.id === this.type);

        if (triggerSequence) {
            return triggerSequence.label;
        }

        return `Type d\'alerte inconnu (${this.type})`;
    }

    public get beaconsAsText(): string {
        if (!this.beacons) {
            return 'N/A';
        }
        return this.beacons.map((beacon) => beacon.beaconName).join(',');
    }
}
